import { v4 as uuidv4 } from 'uuid'
import isEmpty from 'lodash/isEmpty'
import type { ReadonlyURLSearchParams } from 'next/navigation'

export const getQueryParamsObj = (
  searchParams: ReadonlyURLSearchParams | null,
) => {
  const obj = {}
  if (searchParams) {
    for (const [key, value] of searchParams.entries()) {
      obj[key] = value
    }
  }
  return obj
}

export const addQueryParamsToApi = (
  url: string,
  params?: Record<string, string>,
) => {
  const newUrl = isEmpty(params) ? url : `${url}?${new URLSearchParams(params)}`
  return newUrl
}

export const ruppeeCoversion = (val?: number) => {
  if (val) {
    const isDecimal = val % 1 !== 0 && !isNaN(val)
    let item = isDecimal ? val.toString().split('.')[0] : val
    item = item.toString()
    let lastThree = item.substring(item.length - 3)
    const otherNumbers = item.substring(0, item.length - 3)
    if (otherNumbers != '') lastThree = `,${lastThree}`
    const res = `${otherNumbers.replace(
      /\B(?=(\d{2})+(?!\d))/g,
      ',',
    )}${lastThree}`
    return isDecimal ? `${res}.${val.toString().split('.')[1]}` : res
  }
  return val
}

export const nestedArrayCheck = (arr, val) => {
  let returnedValue = []
  arr.forEach(({ value }) => {
    const splitedValue = value.split(',')
    const upiValue = val.split('@')[1]
    const b = splitedValue.filter(data => data.trim() === `@${upiValue}`)
    returnedValue = returnedValue.concat(b)
  })
  return !!returnedValue.length
}

export const createSessionTraceId = (userId: string) => {
  return `session_id=${uuidv4()}${
    userId ? `;user_id=${userId}` : ''
  };requested_by=web`
}

export const createTraceId = (sessionTraceId: string) => {
  return `request_id=${uuidv4()}${
    sessionTraceId ? `;${sessionTraceId}` : ''
  };t=${Date.now()}`
}

export const getSafeJson = <TJsonType extends object>(json?: string) => {
  if (!json) return null

  try {
    return JSON.parse(json) as TJsonType
  } catch {
    return null
  }
}
